document.addEventListener('DOMContentLoaded', () => {
  const loadingScreen = document.getElementById('loading-screen');
  const loadingLogo = document.getElementById('loading-logo');
  const loadingAhLogo = document.getElementById('loading-ah-logo');

  // Check if we're in Shopify editor or local development
  const isInShopifyEditor = Shopify.designMode;
  const isLocalDevelopment =
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('127.0.0.1') ||
    window.location.hostname.includes('.local');

  // Check URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const forceAnimation = urlParams.get('showAnimation') === 'true';

  // Check timestamp
  const lastVisit = localStorage.getItem('lastAnimationTime');
  const currentTime = new Date().getTime();
  const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
  const shouldShowByTime = !lastVisit || currentTime - parseInt(lastVisit) > oneHour;

  // Check if we're on the home page
  const isHomePage = window.location.pathname === '/';

  // Show animation if forced via URL OR
  // (if enough time has passed AND on home page)
  // AND not in editor/local unless forced
  if (!forceAnimation && (!shouldShowByTime || !isHomePage || isInShopifyEditor || isLocalDevelopment)) {
    loadPage();
    return;
  }

  // Update timestamp after showing animation
  localStorage.setItem('lastAnimationTime', currentTime.toString());

  function fadeInOut(callback) {
    // Fade in both logos
    loadingLogo.style.opacity = '1';
    loadingAhLogo.style.opacity = '1';

    // Fade out after delay
    setTimeout(() => {
      loadingLogo.style.opacity = '0';
      loadingAhLogo.style.opacity = '0';
      setTimeout(callback, 1000);
    }, 1000);
  }

  function animateLogo(cycles, callback) {
    if (cycles > 0) {
      fadeInOut(() => animateLogo(cycles - 1, callback));
    } else {
      callback();
    }
  }

  function loadPage() {
    loadingScreen.style.opacity = '0';
    setTimeout(() => {
      loadingScreen.style.display = 'none';
    }, 500);
  }

  // Animate logos 3 times
  animateLogo(2, () => {
    // After 3 cycles, fade out the loading screen
    loadPage();
  });
});
